// Typed BFF client — wraps @crm/api-client con shapes de apps-platform-backend.
import { apiClient } from './api-client'
import type {
  LoginRequest,
  LoginResponse,
  MeResponse,
  TenantMetadata,
  TenantSapp,
  SappToggleResponse,
  HealthCardResponse,
} from '../types/bff'

export const bff = {
  // Auth
  login: (body: LoginRequest) => apiClient.post<LoginResponse>('/auth/login', body),
  logout: () => apiClient.post<{ status: string }>('/auth/logout'),
  me: () => apiClient.get<MeResponse>('/auth/me'),

  // Tenants
  getTenant: (id: string) => apiClient.get<TenantMetadata>(`/tenants/${id}`),
  getTenantSapps: (id: string) => apiClient.get<TenantSapp[]>(`/tenants/${id}/sapps`),
  getTenantHealthCard: (id: string) =>
    apiClient.get<HealthCardResponse>(`/tenants/${id}/health-card`),

  // Admin (dual-write Y3 via Gateway admin)
  toggleSapp: (tenantId: string, slug: string, enabled: boolean) =>
    apiClient.patch<SappToggleResponse>(`/tenants/${tenantId}/sapps/${slug}/toggle`, { enabled }),
}
